module.exports = __webpack_public_path__ + "static/media/background-dark.2b88aadf.webp";